<template>
	<div class="tpl register-wrap">
		<div class="part part1" v-if="showPart==1">
			<mt-header title="注册(1/3)"></mt-header>
			<div class="part-content">
				<div class="greet-text">
					<p>输入手机号</p>
				</div>
				<div class="edit-account">
					<ul>
						<li>
							<input type="tel" placeholder="输入手机号" v-model="tel" />
						</li>
					</ul>
					<div class="part-btn">
						<button @click="toPart2()">下一步，验证手机号</button>
					</div>
					<p class="tips">注册即视为同意《鱼水缘用户协议》</p>
					<router-link tag="p" class="to-login" :to="{name:'login'}">已有账号，去登陆</router-link>
				</div>
			</div>
		</div>
		<div class="part part2" v-if="showPart==2">
			<mt-header title="注册(2/3)"></mt-header>
			<div class="part-content">
				<div class="greet-text">
					<p>验证手机号</p>
					<p class="sub">短信验证码已发送至{{showTel}}</p>
				</div>
				<div class="edit-account">
					<ul>
						<li>
							<input type="text" placeholder="输入验证码" v-model="code" />
							<span class="get-code">
								<span v-if="codeFlag" @click="codeFlag&&getCode()">重新获取</span>
								<span v-else>{{seconds}}s</span>
							</span>
						</li>
					</ul>
					<div class="part-btn">
						<button @click="toPart3">下一步，设置密码</button>
					</div>
					<p class="tips" @click="showPart=1">上一步</p>
				</div>
			</div>
		</div>
		<div class="part part3" v-if="showPart==3">
			<mt-header title="注册(3/3)"></mt-header>
			<div class="part-content">
				<div class="greet-text">
					<p>设置登录密码</p>
				</div>
				<div class="edit-account">
					<ul>
						<li>
							<input type="password" placeholder="输入登录密码" ref="passInput" v-model="password" />
							<span class="icon" @click="passType=!passType">
								<img v-if="passType==0" src="../../assets/img/mine/sl_login_ic_ce.png" alt="" />
								<img v-else src="../../assets/img/mine/sl_login_ic_blink.png" alt="" />
							</span>
						</li>
						<p class="notice">密码需为6位以上数字、字母混合密码</p>
					</ul>
					<div class="part-btn">
						<button @click="toPart4">完成</button>
					</div>
					<p class="tips" @click="showPart=2">上一步</p>
				</div>
			</div>
		</div>
		<div class="info-part part4" v-if="showPart==4">
			<p class="part-title">让大家认识你</p>
			<div class="info-part-content">
				<div class="upload-img">
					<div class="img-show">
						<img v-if="avatar==''" src="../../assets/img/mine/upload-img-default.png" alt="" />
						<img v-else :src="avatar" alt="" />
					</div>
					<input type="file" accept="image/*" @change="uploads" />
				</div>
				<p class="text">上传头像</p>
				<div class="set-nickname">
					<input type="text" placeholder="鱼水缘昵称" v-model="name" />
				</div>
				<div class="part-btn">
					<button @click="toPart5">下一步</button>
				</div>
			</div>
		</div>
		<div class="info-part part5" v-if="showPart==5">
			<div class="info-part-content">
				<div class="choose-sex">
					<p class="part-title">你的性别？</p>
					<p class="part-subtitle">性别选定无法修改</p>
					<div class="sex-options">
						<div class="sex-man" :class="{'active':sex==1}" @click="setSex(1)">
							<div class="sex-icon">
								<img src="../../assets/img/mine/sl_mypr_bg_boy_sel.png" alt="" />
							</div>
							<p class="text">男</p>
						</div>
						<div class="sex-woman" :class="{'active':sex==2}" @click="setSex(2)">
							<div class="sex-icon">
								<img src="../../assets/img/mine/sl_mypr_bg_girl.png" alt="" />
							</div>
							<p class="text">女</p>
						</div>
					</div>
				</div>
				<div class="set-birthday">
					<p class="part-title">你的出生年月？</p>
					<p class="part-subtitle">仅用作推荐视频/图片的依据，鱼水缘会帮你保密</p>
					<p class="birthday-value" @click="openChooseBirthdayPicker">{{showBirthday}}</p>
					<mt-datetime-picker ref="chooseBirthday" v-model="birthday" type="date" :startDate="startDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日">
					</mt-datetime-picker>
				</div>
				<div class="part-btn">
					<button @click="toPart6">下一步</button>
				</div>
			</div>
		</div>
		<div class="info-part part5" v-if="showPart==6">
			<div class="info-part-content">
				<div class="choose-sex">
					<p class="part-title">你所在的城市？</p>
					<p class="part-subtitle">仅用作推荐视频/图片的依据，鱼水缘会帮你保密</p>
					<div class="chooseAdd">
						<p>
							<button @click="selectAdd">{{cityId!=''?addressName.provName+'-'+addressName.cityName:"选择当前所在城市"}}</button>
						</p>
					</div>
				</div>

				<div class="part-btn">
					<button @click="toPart7">下一步</button>
				</div>
			</div>
			<transition name="fade">
				<mt-picker :slots="addressList" @change="setAdd" value-key="name" v-show="chooseAdd" fixed></mt-picker>
			</transition>
		</div>
		<div class="info-part part7" v-if="showPart==7">
			<div class="info-part-content">
				<div class="choose-height">
					<p class="part-title">你的身高？</p>
					<p class="part-subtitle">仅用作推荐视频/图片的依据，鱼水缘会帮你保密</p>
					<div class="chooseValue">
						<p @click="chooseHeight=true;chooseIncome=false">{{height}}cm</p>
					</div>
				</div>
				<div class="choose-income">
					<p class="part-title">年收入</p>
					<div class="chooseValue">
						<p @click="chooseIncome=true;chooseHeight=false">{{income}}</p>
					</div>
				</div>

				<div class="part-btn">
					<button @click="toPart8">下一步</button>
				</div>
			</div>
			<transition name="fade">
				<mt-picker :slots="heightOptions" @change="setHeight" v-show="chooseHeight"></mt-picker>
			</transition>
			<transition name="fade">
				<mt-picker :slots="incomeOptions" @change="setIncome" value-key="name" v-show="chooseIncome"></mt-picker>
			</transition>
		</div>
		<div class="info-part part7" v-if="showPart==8">
			<div class="info-part-content">
				<div class="choose-edu">
					<p class="part-title">你的学历？</p>
					<p class="part-subtitle">鱼水缘为了更精确的推荐/筛选</p>
					<div class="chooseValue">
						<p @click="chooseEdu=true">{{eduLevel}}</p>
					</div>
				</div>
				<div class="edit-ivitid">
					<p class="part-title">你有邀请ID？</p>
					<div class="chooseValue">
						<p><input type="text" placeholder="输入你的邀请ID" v-model="invitationId"/></p>
					</div>
				</div>

				<div class="part-btn">
					<button class="last-btn" @click="submitRegister">开始鱼水缘</button>
				</div>
			</div>
			<transition name="fade">
				<mt-picker :slots="eduOptions" value-key="name" @change="setEdu" v-show="chooseEdu"></mt-picker>
			</transition>
		</div>
	</div>
</template>

<script>
	import Moment from "moment"
	export default {
		name: "register",
		data() {
			return {
				showPart: 1,
				tel: "",
				code: "",
				codeFlag: true,
				codeNum: "",
				password: "",
				passType: false,
				avatar: "",
				avatarFile: "",
				name: "",
				sex: 1,
				startDate: new Date('1968-01-01'),
				birthday: "1990-01-01",
				chooseAdd: false,
				addressName: {
					provName: "",
					cityName: ""
				},
				provId: "",
				cityId: "",
				firstSelect: true,
				addressList: [{
					flex: 1,
					values: [],
					className: 'slot1',
					textAlign: 'center'
				}, {
					divider: true,
					content: '-',
					className: 'slot2'
				}, {
					flex: 1,
					values: [],
					className: 'slot3',
					textAlign: 'center'
				}],
				chooseHeight: false,
				height: 170,
				chooseIncome: false,
				incomeId: 1,
				income: "3W以下",
				eduLevel: "本科",
				eduLevelId: 3,
				chooseEdu: false,
				invitationId: "",
				seconds: 60
			}
		},
		computed: {
			showTel() {
				let t = this.tel.substr(0, 3) + "****" + this.tel.substr(7);
				return t;
			},
			showBirthday() {
				return Moment(this.birthday).format("YYYY-MM-DD");
			},
			heightOptions() {
				let arr = [];
				for(let i = 140; i <= 220; i++) {
					arr.push(i)
				}
				let obj = [{
					flex: 1,
					values: arr,
					className: 'slot1',
					textAlign: 'center',
					defaultIndex: 30
				}, ]
				return obj;
			},
			incomeOptions() {
				let arr = [{
						name: "3W以下",
						id: 1
					},
					{
						name: "3W-5W",
						id: 2
					},
					{
						name: "5W-8W",
						id: 3
					},
					{
						name: "8W-10W",
						id: 4
					},
					{
						name: "10W-15W",
						id: 5
					},
					{
						name: "15W-20W",
						id: 6
					},
					{
						name: "20W以上",
						id: 7
					},
				];
				let obj = [{
					flex: 1,
					values: arr,
					className: 'slot1',
					textAlign: 'center'
				}, ]
				return obj;
			},
			eduOptions() {
				let arr = [{
						name: "大专以下",
						id: 1
					},
					{
						name: "大专",
						id: 2
					},
					{
						name: "本科",
						id: 3
					},
					{
						name: "硕士",
						id: 4
					},
					{
						name: "博士",
						id: 5
					},
					{
						name: "海外留学",
						id: 6
					},
				];
				let obj = [{
					flex: 1,
					values: arr,
					className: 'slot1',
					textAlign: 'center',
					defaultIndex: 2
				}, ]
				return obj;
			},
		},
		watch: {
			passType(newV, oldV) {
				if(newV == true) {
					this.$refs.passInput.type = "text"
				} else {
					this.$refs.passInput.type = "password"
				}
			}
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);

		},
		methods: {
			toPart2() {
				if(!(/^1[34578]\d{9}$/.test(this.tel))) {
					this.$toast({
						message: "请检查手机号是否正确",
						position: "bottom",
						duration: 3000
					})
				} else {
					this.getCode();
					this.showPart = 2;
				}
			},
			toPart3() {
				if(this.code != this.codeNum) {
					this.$toast({
						message: "请检查验证码是否正确",
						position: "bottom",
						duration: 3000
					})
				} else {
					this.showPart = 3;
				}
			},
			toPart4() {
				var regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
				var regString = /[a-zA-Z]+/; //验证大小写26个字母任意字母最少出现1次。
				if(regNumber.test(this.password) && regString.test(this.password) && this.password.length > 6) {
					this.showPart = 4;
				} else {
					this.$toast({
						message: "请检查密码是否符合规范",
						position: "bottom",
						duration: 3000
					})
				}
			},
			toPart5() {
				if(this.avatar == "" || this.name == "") {
					this.$toast({
						message: "检查头像和昵称是否设置",
						position: "bottom",
						duration: 3000
					})
				} else {
					this.showPart = 5;
				}
			},
			toPart6() {
				if(this.sex == "" || this.birthday == "") {
					this.$toast({
						message: "检查性别和生日是否选择",
						position: "bottom",
						duration: 3000
					})
				} else {
					this.showPart = 6;
				}
			},
			toPart7() {
				if(this.cityId == "") {
					this.$toast({
						message: "请重新选择所在城市",
						position: "bottom",
						duration: 3000
					})
				} else {
					this.showPart = 7;
				}
			},
			toPart8() {
				if(this.height == "" || this.incomeId == "") {
					this.$toast({
						message: "检查身高和收入是否选择",
						position: "bottom",
						duration: 3000
					})
				} else {
					this.showPart = 8;
				}
			},
			submitRegister(){
				console.log(this.name,this.avatarFile,this.tel,this.password,this.code,this.invitationId,this.cityId,this.sex,this.showBirthday,this.height,this.incomeId,this.eduLevel,);
				let data = new FormData();
				data.append("nickname", this.name);
				data.append("avatar", this.avatarFile);
				data.append("phone", this.tel);
				data.append("password", this.$md5(this.password));
				data.append("check_code", this.code);
				data.append("referee", this.invitationId);
				data.append("city", this.cityId);
				data.append("gender", this.sex);
				data.append("birthday", this.showBirthday);
				data.append("height", this.height);
				data.append("annual_income", this.incomeId);
				data.append("education", this.eduLevel);
				data.append("login_type", 2);
				data.append("type", "phone");
				this.$axios({
					url:"User/register",
					method:"post",
					data:data
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message: "注册成功",
							position: "bottom",
							duration: 3000
						});
						this.$store.commit("getUserId",res.data.data.uid);
						this.$router.push({name:"mine"})
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			getCode() {
				if(!this.codeFlag) {
					this.$toast({
						message: "操作过于频繁！",
						position: "bottom",
						duration: 3000
					});
				} else if(!(/^1[34578]\d{9}$/.test(this.tel))) {
					this.$toast({
						message: "请检查手机号是否正确",
						position: "bottom",
						duration: 3000
					});
				} else {
					this.$axios({
						url:'Sms/mobilePhoneCheckCode',
						method:"post",
						data:{
							phone:this.tel,
							type:"A"
						}
					}).then(res=>{
						if(res.data.code==200){
							this.$toast({message:"验证码发送成功！",position:"bottom",duration:3000})
							this.codeNum = res.data.data.msgTxt;
							console.log(this.codeNum,this.code);
							this.codeFlag = false;
							this.culTime();
						}else{
							this.$toast({message:res.data.msg,position:"bottom",duration:3000});
							this.codeFlag = true;
							return false;
						}
					}).catch(err=>{
						console.log(err)
					})
				}

			},
			culTime() {
				let _this = this;
				let t = setInterval(function() {
					if(_this.seconds > 0) {
						_this.seconds--
					} else {
						_this.seconds = 60;
						_this.codeFlag = true;
						clearInterval(t)
					}

				}, 1000)
			},
			uploads(e) {
				const file = e.target.files[0];
				let URL = window.URL || window.webkitURL;
				this.avatar = URL.createObjectURL(file);
				this.avatarFile = file;
				console.log(this.avatarFile, this.avatar);
			},
			setSex(id) {
				this.$messagebox.confirm('确定执行此操作?').then(action => {
					this.sex = id;
				});
				this.$messagebox.confirm('', {  
					 message: '性别设定后无法更改，确认吗？',
					 title: '',
					 confirmButtonText: '确认',
					 cancelButtonText: '再想想'
				}).then(action => {  
					if(action == 'confirm') {   //确认的回调
						this.sex = id; 
					} 
				}).catch(err => {  
					if(err == 'cancel') {   //取消的回调
						 
					}  
				});

			},
			openChooseBirthdayPicker() {
				this.$refs.chooseBirthday.open()
			},
			selectAdd() {
				this.chooseAdd = !this.chooseAdd;
				this.getAddressInfo(1, {
					success: (res) => {
						this.addressList[0].values = res
					}
				})
			},
			getAddressInfo(id, options) {
				this.$axios({
					url: "Currency/getRegionInfoList",
					method: "post",
					data: {
						region_id: id,
					}
				}).then(res => {
					if(res.data.code == 200) {
						let a = res.data.data.map(function(item) {
							let obj = {};
							obj.name = item.region_name;
							obj.id = item.region_id;
							return obj;
						})
						console.log(a);
						if(!!options && !!options.success) {
							options.success(a)
						}
					}
				}).catch(err => {
					console.log(err)
				})

			},
			setAdd(picker, value) {
				if(value[0]) {
					this.provId = value[0].id;
					this.addressName.provName = value[0].name;
					this.getAddressInfo(value[0].id, {
						success: (res) => {
							picker.setSlotValues(1, res);
						}
					})
					if(value[1]) {
						this.cityId = value[1].id;
						this.addressName.cityName = value[1].name;
					}
				}
			},
			setHeight(index, value) {
				this.height = value[0]
			},
			setIncome(index, value) {
				this.income = value[0].name;
				this.incomeId = value[0].id;
			},
			setEdu(index, value) {
				this.eduLevel = value[0].name;
				this.eduLevelId = value[0].id;
			}
		}
	}
</script>

<style scoped>
	.mint-header {
		border-bottom: 0 !important;
	}
	
	.register-wrap {
		width: 100vw;
		min-height: 100vh;
		background: #fff;
	}
	
	.register-wrap .part-content {
		padding: 5rem 1.5rem 0;
		background: #fff;
	}
	
	.greet-text {
		font-size: 1.5rem;
		color: #282828;
		line-height: 2.5rem;
		margin-bottom: 2rem;
	}
	
	.greet-text .sub {
		font-size: 0.8rem;
		color: #7b7b7b;
		line-height: 1.5rem;
	}
	
	.edit-account li {
		border-bottom: 1px solid #f3f3f3;
		position: relative;
	}
	
	.edit-account li input {
		width: 100%;
		height: 2.5rem;
		border: 0;
		background: none;
		outline: 0;
		padding: 0 0.5rem;
		font-size: 0.8rem;
	}
	
	.edit-account li .get-code {
		position: absolute;
		font-size: 0.7rem;
		background: rgba(255, 97, 97, .6);
		padding: 0.2rem 0.6rem;
		color: #fff;
		border-radius: 3px;
		right: 0;
		top: 0.5rem;
	}
	
	.edit-account li .icon {
		position: absolute;
		right: 0;
		top: 0.5rem;
	}
	
	.edit-account li .icon img {
		width: 1.5rem;
	}
	
	.edit-account li .get-code:active {
		opacity: 0.7;
	}
	
	.options {
		font-size: 0.6rem;
		color: #282828;
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 2.4rem;
		padding: 0 0.5rem;
	}
	
	.options span:active {
		opacity: 0.7;
	}
	
	.part-btn {
		padding: 1rem 0.5rem;
		width: 100%;
	}
	
	.part-btn button {
		width: 100%;
		height: 2.5rem;
		color: #7b7b7b;
		font-size: 0.8rem;
		background: #eee;
		border: 0;
		outline: 0;
		border-radius: 5px;
	}
	
	.part .tips {
		font-size: 0.65rem;
		color: #7b7b7b;
		text-align: center;
	}
	
	.part .to-login {
		margin: 4rem 0 2rem;
		color: #282828;
		font-size: 1rem;
		text-align: center;
	}
	
	.part .notice {
		font-size: 0.65rem;
		line-height: 1rem;
		color: #7b7b7b;
		padding: 0.3rem;
	}
	
	.info-part {
		padding: 5rem 1rem 1rem;
	}
	
	.info-part .part-title {
		font-size: 1.5rem;
		color: #282828;
		font-weight: 500;
		text-align: center;
		margin-bottom: 3rem;
	}
	
	.info-part-content {
		text-align: center;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-direction: column;
	}
	
	.info-part-content .upload-img {
		width: 4rem;
		height: 4rem;
		position: relative;
	}
	
	.info-part-content input[type='file'] {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0;
	}
	
	.info-part-content .img-show {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		border-radius: 50%;
		overflow: hidden;
	}
	
	.info-part-content .img-show img {
		width: 100%;
		height: 100%;
	}
	
	.info-part-content .text {
		text-align: center;
		color: #282828;
		font-size: 0.8rem;
		margin: 1rem;
		line-height: 1.5rem;
	}
	
	.info-part-content .set-nickname {
		margin-bottom: 6rem;
	}
	
	.info-part-content .set-nickname input {
		width: 100%;
		margin: 3rem auto;
		text-align: center;
		border: 0;
		outline: 0;
		background: none;
		font-size: 1rem;
		color: #7B7B7B;
		line-height: 1.5rem;
		border-bottom: 1px solid #f3f3f3;
	}
	
	.info-part.part5 .part-title,
	.info-part.part7 .part-title {
		margin-bottom: 0.5rem;
	}
	
	.info-part.part5 .part-subtitle,
	.info-part.part7 .part-subtitle {
		font-size: 0.8rem;
		color: #7B7B7B;
		text-align: center;
		margin-bottom: 1.5rem;
	}
	
	.choose-sex {
		margin-bottom: 3rem;
	}
	
	.sex-options {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.sex-options>div {
		padding: 1rem;
		margin: 0 1rem;
		opacity: 0.6;
	}
	
	.sex-options>div.active {
		opacity: 1;
	}
	
	.sex-options .sex-man.active .sex-icon {
		border: 1px solid #01aef0;
	}
	
	.sex-options .sex-woman.active .sex-icon {
		border: 1px solid #FF6161;
	}
	
	.sex-options .sex-icon {
		padding: 0.5rem;
		border: 1px solid transparent;
		border-radius: 50%;
	}
	
	.sex-options .sex-icon img {
		width: 3rem;
		display: block;
	}
	
	.sex-options .text {
		margin: 0;
	}
	
	.set-birthday .birthday-value {
		font-size: 1.5rem;
		margin-bottom: 3rem;
	}
	
	.chooseAdd {
		padding: 2rem;
	}
	
	.chooseAdd img {
		width: 2rem;
		margin-bottom: 1rem;
	}
	
	.chooseAdd button {
		padding: 0.6rem 1.5rem;
		color: #7b7b7b;
		outline: 0;
		border: 1px solid #f0f0f0;
		background: #fff;
		border-radius: 3rem;
	}
	
	.part7>div>div {
		width: 100%;
	}
	
	.part7 .choose-income {
		margin-top: 3rem;
	}
	
	.part7 .chooseValue {
		font-size: 1.5rem;
		margin: 2rem auto;
		border-bottom: 1px solid #f3f3f3;
		width: 80%;
		padding: 0.5rem;
	}
	
	.picker {
		position: fixed;
		width: 100%;
		left: 0;
		bottom: 0;
	}
	
	>>>.picker-item {
		font-size: 0.8rem;
		opacity: 0.7;
		transition: 200ms;
	}
	
	>>>.picker-item.picker-selected {
		font-size: 1rem;
		opacity: 1;
	}
	
	.edit-ivitid {
		margin-top: 3rem;
	}
	
	.edit-ivitid input {
		outline: 0;
		border: 0;
		background: none;
		text-align: center;
	}
	
	.part-btn .last-btn {
		background: rgba(84, 21, 249, .7);
		color: #fff;
	}
	>>>.mint-msgbox-confirm{
		color: #5415F9;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/Register.vue